
<template>

<Loader v-if="loader" /> 
<Toast position="bottom-right" />

    <div class="table-container">

      <div class="mb-2">
        <Accordion>
          <AccordionTab header="Upload File">
            <div class="formgrid grid form-file">
              <div class="field col-12 md:col-7">
                <div class="text-center allowed-format"> Formati consentiti: {{Object.keys(allowedType).join(', ')}} </div>
                <div class="button-wrapper">
                  <span :class="['label', {'active': fileToUpload.length > 0}]">
                    {{fileToUpload.length > 0 ? fileToUpload[0].name : 'Seleziona File' }}
                  </span>
                  <input id="upload" type="file" ref="file" :key="keyInputReset" @change="handleFileUpload( $event )" :accept="`${Object.values(allowedType).join(', ')}`" />
                </div>
                <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
                <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
              </div>
              <div class="field col-12 md:col-3">
                <label>Provider:</label>
                <Dropdown v-model="selectedProvider" :options="providers" optionLabel="name"  placeholder="Seleziona gestore" class="inputfield w-full" />
                <div v-show="validationErrors.gestore && submitted" class="p-error">Campo richiesto.</div>
              </div>
              <div class="field col-12 md:col-2 flex align-items-end">
                <Button @click="uploadFile" class="w-full" label="Carica" />
              </div>
            </div>
          </AccordionTab>
        </Accordion>
      </div>
      

      <div class="card">
          <div class="formgrid grid ">
              <div class="field col-6 md:col-3">
                  <label>Pod/Pdr</label>
                  <InputText v-model="fornitura" class="inputfield w-full" placeholder="" />
              </div>
              <div class="field col-6 md:col-4">
                  <label>Tipo</label>
                  <MultiSelect v-model="selectedType" :options="types" optionLabel="code" :filter="true" :filterFields="['code', 'string']"  placeholder="Seleziona una tipologia" class="inputfield w-full multiselect-custom">
                    <template #value="slotProps">
                        <span v-for="option of slotProps.value" :key="option.code">
                            {{option.code}} - {{option.string}}
                        </span>
                    </template>
                    <template #option="slotProps">
                        <div>
                            <div>{{slotProps.option.code}} - {{slotProps.option.string}}</div>
                        </div>
                    </template>
                  </MultiSelect>
              </div>
              <div class="field col-6 md:col-3">
                  <label>Periodo</label>
                  <Calendar v-model="period" class="inputfield w-full" :showIcon="true" dateFormat="dd-mm-yy" selectionMode="range" :manualInput="false" />
              </div>
                <div class="field col-12 md:col-2 flex align-items-end">
                  <Button label="Cerca" icon="pi pi-search" iconPos="left" class="w-full" @click="searchData" />
              </div>
              <div class="field col-12 align-items-end">                
                  <p v-if="searchActive" class="p-error w-1" @click="resetFilter">Rimuovi filtri</p>             
              </div>
          </div>
      </div>
      <div class="card">
          <DataTable ref="dt" :value="items"  :paginator="true" :rows="10" :filters="filters"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll"
              currentPageReportTemplate="{first} a {last} di {totalRecords}">
              <template #header>
                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center mb-2">
                      <span class="p-input-icon-left">
                          <i class="pi pi-search" />
                          <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                      </span>
                    </div>
                    <div class="flex align-items-center justify-content-center">
                      <Button icon="pi pi-download" label="Esporta" @click="exportCSV($event)" class="p-button-secondary" />
                    </div>
                </div>
              </template>
              <template #empty>
                  <div class="text-center">Nessun dato trovato.</div>
              </template>
              <Column field="fornitura" header="Fornitura" :sortable="true">
              <template #body="{data}">
                <p v-if="data.pod_id == 0 && data.pdr_id == 0">
                {{data.fornitura}}
                </p>
                <p v-else>
                  <span v-if="data.pod_id != 0">
                    <router-link :to="`/ask/pods/${data.pod_id}/dettagli`" target="_blank">
                      {{data.fornitura}}
                    </router-link>
                  </span>
                  <span v-else>
                    <router-link :to="`/ask/pdrs/${data.pdr_id}/dettagli`" target="_blank">
                      {{data.fornitura}}
                    </router-link>
                  </span>
                </p>
              </template>
              </Column>
              <Column field="cliente" header="Cliente" :sortable="true"></Column>
              <Column field="piva" header="P.iva" :sortable="true"></Column>
              <Column field="codfis" header="C.fiscale" :sortable="true"></Column>
               <Column field="rappresentante" header="Rappresentante" :sortable="true"></Column>
               <Column field="agente" header="Agente" :sortable="true"></Column>
              <Column field="cod_servizio" header="Code" :sortable="true"></Column>
              <Column field="type" header="Tipo" :sortable="true"></Column>
              <Column field="provider" header="Provider" :sortable="true"  class="provider"></Column>
              <Column field="cod_pratica" header="Codice pratica interno"></Column>           
              <Column field="cod_pratica_provider" header="Codice pratica provider"></Column>           
              <Column field="costo_imponibile" header="Imponibile" :sortable="true"></Column>
              <Column field="costo_iva" header="Iva" :sortable="true"></Column>
              <Column field="costo_totale" header="Totale" :sortable="true"></Column>
              <Column field="data_pratica" header="Data Pratica" :sortable="true">
                  <template #body="slotProps">
                  {{formatDate(slotProps.data.data_pratica)}}
                  </template>
              </Column>
              <Column field="data_decorrenza" header="Data Decorrenza" :sortable="true">
                  <template #body="slotProps">
                  {{formatDate(slotProps.data.data_decorrenza)}}
                  </template>
              </Column>
              <Column field="data_esito" header="Data Esito" :sortable="true">
                  <template #body="slotProps">
                  {{formatDate(slotProps.data.data_esito)}}
                  </template>
              </Column>
              <Column field="esito_pratica" header="Esito" :sortable="true"></Column>
              <Column field="motivazione_esito" header="Motivazione Esito" :sortable="true"></Column>
              <Column>
                <template #body="{data}">
                  <div v-if="data.provider == 'four'">
                    <Button @click="updatePratica(data)" icon="pi pi-refresh" class="p-button-rounded p-button-outlined" />
                  </div>
                </template>
              </Column>
          </DataTable>
      </div>                        
    </div>
</template>

<script>
import moment from 'moment'
import { FilterMatchMode } from 'primevue/api';
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance  } from 'vue';
import { useToast } from "primevue/usetoast";
import Loader from '@/components/Loader.vue'

export default {
    components: {
      Loader
    },
     setup() {
        
        const loader = ref(false)
        const dt = ref();
        const toast = useToast();
        const items = ref([]);
        const selectedType = ref();
        const fornitura= ref();
        const types = ref([]);
        const period = ref();
        const fileToUpload = ref([])
        const keyInputReset = ref(0)
        const searchActive = ref(false)
        const filters = ref({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        });
        const allowedType = {
          'xlsx' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'csv' : 'text/csv'
        }
        const selectedProvider = ref(null)
        const providers = ref([
          // {name:'acquirente-unico'},
          // {name:'a2a'},
        ])
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        self.$http = self.appContext.config.globalProperties.$http
        const formatDate = self.appContext.config.globalProperties.$formatDate
        const service = new Service(self.$http, self.$eventBus)
        const validationErrors = ref({})
        const submitted = ref(false)

        onMounted(() => {
          getMassiveTypes()
          getProviders()
          // getData();                
        })

        const getMassiveTypes = () => {
          service.getMassiveTypes().then((res) => {
            types.value = res.items
          })
        }

        const getProviders = () => {
          service.getProviders().then((res) => {
            console.log(res);
            providers.value = res.items
          })
        }

        // const getData = () => {
        //   loader.value = true; 
        //   service.getMassiveRequest().then((res) => {
        //     items.value = res.items
        //   }).finally(() => {
        //     loader.value = false; 
        //   })
        // }

        
        const searchData = () => {  
          if (fornitura.value || selectedType.value || period.value) {
              loader.value = true; 
              searchActive.value = true
              items.value = []
              let dates = stringDate(period.value)     
              service.getMassiveRequestSearch(fornitura.value, selectedType.value, dates).then((res) => {
                  items.value = res.items
              }).finally(() => {
                  loader.value = false; 
              })  
          }
        }

        const stringDate = (dates) => {
          let period = [];
          if (dates) {
              if (dates[0]) {
              period.push(moment(dates[0]).format('YYYY-MM-DD'));
              }
              if (dates[1]) {
                  period.push(moment(dates[1]).format('YYYY-MM-DD'));
              } 
          }        
          return period
        }

        const resetFilter = () => {
          // getData()
          items.value = []
          searchActive.value = false
          fornitura.value = ''
          selectedType.value = ''
          period.value = ''
        }

        const handleFileUpload = async (evt) => {
          fileToUpload.value = []
          evt.preventDefault()
          submitted.value = false;
          fileToUpload.value = self.refs.file.files
        }

        
        const uploadFile = () => {
          submitted.value = true
          if (validateFiles()) {
            loader.value = true; 
            service.uploadFilePratiche(fileToUpload.value, selectedProvider.value)
            .then((res) => {
              toast.add({severity:'success', summary: 'Successo', detail:res.items.msg});
              if(res.items.pod_not_found.length > 0 || res.items.pdr_not_found.length > 0){
                toast.add({severity:'warn', summary: 'Attenzione', detail:'Alcune forniture non trovate nel sistema'});
              } 
            }).finally(() => {
              keyInputReset.value = new Date()
              fileToUpload.value = []
              loader.value = false; 
              getMassiveTypes()
            }) 
          }
        }

        const updatePratica = (data) => {
          loader.value = true; 
          service.updatePratica(data.cod_pratica_provider)
          .then(() => {
            searchData()
          }).finally(() => {
            loader.value = false; 
          }) 
        }


        const exportCSV = () => {
          dt.value.exportCSV();
        };

        const validateFiles= () => {
          validationErrors.value = []
          if (fileToUpload.value.length == 0) {
            validationErrors.value['files'] = true;
            delete validationErrors.value['type'];
          } else {
            delete validationErrors.value['files'];
          }

          if (fileToUpload.value.length > 0) {
            let valid = [...fileToUpload.value].every(file => Object.values(allowedType).includes(file.type), false);
            if (valid) {
              delete validationErrors.value['type'];
            } else {
              validationErrors.value['type'] = true;
            }
          }

          if (selectedProvider.value == null || selectedProvider.value.length == 0) {
              validationErrors.value['gestore'] = true;
          } else {
            delete validationErrors.value['gestore'];
          }
          return !Object.keys(validationErrors.value).length;
        }

        return { 
          dt, 
          items, 
          service, 
          // getData,
          selectedProvider,
          providers,
          fornitura,
          types, 
          selectedType, 
          period, 
          searchData,
          formatDate, 
          filters, 
          resetFilter, 
          searchActive,
          fileToUpload,
          allowedType,
          keyInputReset,
          updatePratica,
          exportCSV,
          validationErrors,
          submitted,
          handleFileUpload,
          uploadFile,
          loader
        }
    }
}
</script>

<style scoped>
.form-file .button-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px dashed rgb(156, 156, 156);
  text-align: center;
  justify-content: center;
  display: flex;
  align-items: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  /* border: 1px solid rgb(217, 217, 217) !important;  */
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
}

.form-file .button-wrapper span.label.active {
  color: #2196F3;
}

.form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}
</style>
